import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

export default function PurchaseOrderStats({ totalOrders, totalValue }) {
  return (
    <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
      <Card sx={{ flex: 1, borderRadius: 2, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
        <CardContent sx={{ p: 2.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Total de Pedidos
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 600, color: "#424242" }}>
                {totalOrders}
              </Typography>
            </Box>
            <Box
              sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: "#fff3e0",
                color: "#ff9800"
              }}
            >
              <AssignmentIcon sx={{ fontSize: 24 }} />
            </Box>
          </Box>
        </CardContent>
      </Card>
      
      <Card sx={{ flex: 1, borderRadius: 2, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
        <CardContent sx={{ p: 2.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Valor Total
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 600, color: "#424242" }}>
                R$ {totalValue.toLocaleString("pt-BR", { minimumFractionDigits: 0 })}
              </Typography>
            </Box>
            <Box
              sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: "#e8f5e8",
                color: "#4caf50"
              }}
            >
              <AttachMoneyIcon sx={{ fontSize: 24 }} />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}